import React from 'react';

export default () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="9.12547" height="9.12547" fill="currentColor" />
    <rect x="10.875" width="9.12547" height="9.12547" fill="currentColor" />
    <rect y="10.873" width="9.12547" height="9.12547" fill="currentColor" />
    <rect
      x="10.875"
      y="10.873"
      width="9.12547"
      height="9.12547"
      fill="currentColor"
    />
  </svg>
);
